/*global CustomFunctions*/
import { PARAMETER_TYPE_BY_ID_BATCHER } from "../../shared/batchers";
import { FormulaErrorFormat } from "../../shared/types";
import { isGuid, formulaErrorHandling } from "../../shared/helpers";
import { observerForCustomFunction } from "../../shared/query-client";

/**
 * Gets DDB parameter type name.
 * @customfunction PARAMETER_TYPE.NAME
 * @param parameterTypeId The parameter type ID.
 * @returns The parameter type name.
 * @streaming
 */
export function parameterTypeName(
  parameterTypeId: string,
  invocation: CustomFunctions.StreamingInvocation<string>
): void {
  if (!isGuid(parameterTypeId)) {
    invocation.setResult(formulaErrorHandling(FormulaErrorFormat.PARAMETER_TYPE_ID));
    return;
  }

  observerForCustomFunction(invocation, {
    queryKey: ["parameterType", parameterTypeId],
    queryFn: async () => PARAMETER_TYPE_BY_ID_BATCHER.fetch(parameterTypeId),
    select: ({ name }) => name,
  });
}

CustomFunctions.associate("PARAMETER_TYPE.NAME", parameterTypeName);